module.exports = __webpack_public_path__ + "static/img/webinar-icon.5a6ac9ee.gif";